
@if (showMenu) {
  <div class="menu mega-menu two-levels">
    <div class="row">
      <!-- First level -->
      <div class="col-sm-5 right-bordered">
        <ul class="list-unstyled">
          @for (menuLink of customMenuLinks; track menuLink) {
            <li class="menu-item link-item custom-menu-link clearfix"
              (click)="customLinkClicked(menuLink)"
              (mouseenter)="hideMenuGroups()">
              <span class="fas fa-circle"></span> <span class="link-name" [innerHTML]="menuLink.name"></span>
            </li>
          }
          @for (group of menuGroups; track group) {
            <li class="menu-item header-item clearfix" [class.active]="activeMenuGroup == group"
              (mouseenter)="hideMenuGroups(); selectedMenuGroup = group; activeMenuGroup = group"
              (mouseleave)="activeSecondMenuGroup = undefined;"
              (touchstart)="hideMenuGroups(); selectedMenuGroup = group; activeMenuGroup = group"
              (touchend)="activeSecondMenuGroup = undefined;">
              {{group.title}} <span class="float-end light-gray fas fa-lg fa-chevron-right"></span>
            </li>
          }
        </ul>
        @if (firstLevelMenuLinks?.length > 0) {
          <ul
            class="list-unstyled border-top-0"
            (mouseenter)="activeMenuGroup = undefined; selectedMenuGroup = undefined;">
            @for (menuLink of firstLevelMenuLinks; track menuLink) {
              <li class="menu-item link-item clearfix"
                (click)="goTo(menuLink)"
                [ngbTooltip]="menuLink.tooltip ? menuLink.tooltip : null" placement="bottom">
                <span class="fas fa-circle"></span> <span class="link-name" [innerHTML]="menuLink.name"></span>
              </li>
            }
          </ul>
        }
      </div>
      <!-- Second level -->
      <div class="col-sm-7" [class.right-bordered]="selectedMenuGroup && selectedMenuGroup.groupChildren">
        @if (selectedMenuGroup) {
          <div [id]="selectedMenuGroup.groupId">
            <p class="menu-group-title d-block d-sm-none">{{selectedMenuGroup.title}}</p>
            @if (selectedMenuGroup.linkChildren) {
              <ul class="list-unstyled">
                @for (linkChild of selectedMenuGroup.linkChildren; track linkChild) {
                  <li class="menu-item link-item clearfix"
                    (click)="goTo(linkChild)"
                    [ngbTooltip]="linkChild.tooltip ? linkChild.tooltip : null" placement="bottom">
                    <span class="fas fa-circle"></span> <span class="link-name" [innerHTML]="linkChild.name"></span>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    </div>
  </div>
}